const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.752 21.472H15.36V2.30402L8.16 17.728L0.960001 2.27202V22.432L0 22.4V1.24443e-05H0.960001L8.16 15.456L15.36 0.032012H16.32V22.432L2.752 22.4V21.472Z",
  fill: "#640507"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.36 21.472L24.1919 21.472L20.32 10.848L22.112 9.82407C23.5839 9.01341 24.3199 7.72274 24.3199 5.95207C24.3199 2.64541 21.3546 0.959956 16.32 0.959956V22.432L15.36 22.4297V0.032012H16.32C20.5 1.24425e-05 21.7066 0.554736 23.1359 1.60007C24.5653 2.62407 25.2799 4.07474 25.2799 5.95207C25.2799 8.08541 24.3839 9.65341 22.592 10.656L21.504 11.264L25.5679 22.432H15.36V21.472Z",
  fill: "#640507"
});
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17d87a6fad7b9e431457bf0f7038008d.svg";
export { ForwardRef as ReactComponent };